<div class="locker-container relative">
  <!-- Container for SVGs -->
  <div class="svg-scroll-container">
    @for (item of SVGs(); track $index) {
    <div class="svg-wrapper">
      <div [innerHTML]="item"></div>
      @if (modulesIndexes()[$index]) {
      <div
        class="module-label"
        [class.broken]="modulesIndexes()[$index] === -1"
        (click)="markModuleAsBroken(modulesIndexes()[$index])"
      >
        Module {{ modulesIndexes()[$index] }}
      </div>
      }
    </div>
    }
  </div>

  <div class="absolute right-0 flex align-items-center" style="bottom: -15%">
    <p-button
      #legendBtn
      size="large"
      icon="pi pi-info-circle"
      (click)="op.toggle($event)"
    >
    </p-button>
  </div>
</div>

<p-overlayPanel #op [style]="{ width: '300px' }">
  <ng-template pTemplate>
    <h4 class="m-0 mb-2 text-lg font-medium">Legendǎ statusuri</h4>
    <div class="legend-grid">
      @for (state of stateInfo; track state.name) {
      <div class="legend-item mb-2">
        <div class="flex align-items-center">
          <div
            class="color-box mr-2"
            [style.background-color]="state.color"
          ></div>
          <div>
            <div class="text-sm text-color-secondary">
              {{ state.translatedLabel }}
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </ng-template>
</p-overlayPanel>

<p-dialog
  [visible]="showModuleConfirmationDialog()"
  (visibleChange)="showModuleConfirmationDialog.set($event)"
  header="Confirmare marcare modul ca stricta/reparat"
  [modal]="true"
  [style]="{ width: '450px' }"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [closable]="true"
>
  <div class="dialog-content">
    <div class="flex align-items-center mb-3">
      <i
        class="pi pi-exclamation-triangle mr-2"
        style="font-size: 1.5rem; color: var(--yellow-500)"
      ></i>
      <p>Suneti sigur ca vreti sa marcati modul ca stricat/reparat?</p>
    </div>
    <div class="field mt-4">
      <label for="reason" class="block font-medium mb-2">
        Motivul acțiunii: <span class="text-sm text-gray-500">(opțional)</span>
      </label>
      <textarea
        id="reason"
        pInputTextarea
        [ngModel]="actionReason()"
        (ngModelChange)="this.actionReason.set($event)"
        rows="3"
        class="w-full"
        placeholder="Introduceți motivul pentru această acțiune (opțional)..."
      ></textarea>
    </div>
  </div>

  <p>
    Pentru a continua, va rugam sa tastati <b>"{{ "CONFIRM BROKEN MODULE" }}"</b> in
    campul de mai jos
  </p>
  <input pInputText [value]="securityKeywordControl()" class="w-full" />

  <ng-template pTemplate="footer">
    <p-button
      label="Nu"
      icon="pi pi-times"
      styleClass="p-button-text"
      (click)="showModuleConfirmationDialog.set(false)"
    ></p-button>
    <p-button
      label="Da"
      icon="pi pi-check"
      [disabled]="!canProceed()"
      (click)="confirmActionWithReason()"
    ></p-button>
  </ng-template>
</p-dialog>
